// Folio Charge model
import { useStore } from "storev2/formStore";
import dates from "componentsv2/tools/dates";

const model = "hotel.folio.charge";

function onSearchProduct() {
  const res = [
    ["account_category", "!=", null],
    ["salable", "=", true],
  ];
  return res;
}

function onChangeValue(storeId, record) {
  const { active } = record;
  const { updateForm } = useStore.getState();
  if (active.product) {
    active.amount = (Number(active.unit_price_w_tax) * Number(active.quantity))
      .toFixed(2)
      .toString();
  }
  updateForm(storeId, active);
}

function onChangeProduct(storeId, record) {
  const { store, active } = record;
  const { updateForm } = useStore.getState();
  if (active.product) {
    const product = active.product;
    const unit_price = product.list_price;
    const sale_price_taxed = product.sale_price_taxed;
    store.unit_price = unit_price;
    active.unit_price = unit_price;
    store.unit_price_w_tax = sale_price_taxed;
    active.unit_price_w_tax = sale_price_taxed;
    store.description =  product.description || product.name;
    active.description = product.description || product.name;
    if (active.quantity) {
      active.amount = active.quantity * sale_price_taxed;
    }
  }
  updateForm(storeId, active, store);
}

function getAmount(record) {
  if (record.unit_price_w_tax && record.quantity) {
    return (record.unit_price_w_tax * Number(record.quantity))//.toFixed(2);
  }
  return 0;
}

function onAccessEdit(record) {
  return record.status !== "draft";
}

function onAccess(record) {
  return record.status === "draft";
}

function getRoom(record) {
  return record?.folio?.room;
}

function layout(props) {
  const selectable = props?.selectable;
  const table_action = props ? props.table_action : ["add", "edit"];
  const ctxView = {
    model: model,
    form_action: ["add", "edit", "delete"],
    table_action: table_action,
    domain: [],
    orderBy: [["sale_date", "ASC"]],
    limit: 100,
    autoSave: true,
    selectable: selectable,
    target: "folio",
    access: {
      delete: onAccess,
      edit: onAccess,
    },
    fields: {
      sale_date: {
        type: "date_2",
        default: dates.dateToday(),
        required: true,
        readOnly: onAccessEdit,
      },
      kind: {
        type: "selection",
        readOnly: true,
        default: { id: "product", name: "product" },
        translate: true,
        options: [
          { id: "product", name: "product" },
          { id: "accommodation", name: "accommodation" },
        ],
      },
      amount: {
        type: "numeric",
        readOnly: true,
        function: getAmount,
        decimalPlaces: 2,
      },
      status: {
        type: "char",
        readOnly: true,
        translate: true,
        default: "draft",
      },
      folio: {
        type: "many2one",
        model: "hotel.folio",
        readOnly: true,
      },
      description: {
        type: "char",
        readOnly: true,
      },
      invoice_line: {
        type: "many2one",
        model: "account.invoice.line",
        readOnly: true,
      },
      product: {
        type: "many2one",
        model: "product.product",
        required: true,
        readOnly: onAccessEdit,
        recSearch: onSearchProduct,
        withChange: onChangeProduct,
        attrs: [
          "id",
          "list_price",
          "name",
          "sale_price_taxed",
          "sale_uom.rec_name",
          "description"
        ],
      },
      quantity: {
        type: "integer",
        default: 1,
        required: true,
        withChange: onChangeValue,
        readOnly: onAccessEdit,
        decimalPlaces: 2,
      },
      order: {
        type: "char",
        readOnly: true,
        // default: 1,
      },
      unit_price_w_tax: {
        type: "numeric",
        required: true,
        decimalPlaces: 2,
        withChange: onChangeValue,
        readOnly: onAccessEdit,
      },
    },
    list: [
      { name: "sale_date", width: "10%" },
      { name: "product", width: "25%" },
      { name: "description", width: "15%" },
      { name: "quantity", width: "10%" },
      { name: "unit_price_w_tax", width: "20%" },
      { name: "amount", width: "15%" },
      // { name: "status", width: "15%" },
    ],
    form: [
      { name: "product" },
      {
        type: "grid",
        name: "grid1",
        elements: [{ name: "sale_date" }, { name: "folio" }],
        colSpan: "col-span-1",
      },
      {
        type: "grid",
        name: "grid2",
        elements: [{ name: "quantity" }, { name: "unit_price_w_tax" }],
        colSpan: "col-span-1",
      },
      {
        type: "grid",
        name: "grid3",
        elements: [{ name: "amount" }, { name: "status" }],
        colSpan: "col-span-1",
      },
      { name: "order" },
      { name: "invoice_line" },
    ],
  };

  return ctxView;
}

export { layout };
